module.exports = __webpack_public_path__ + "img/平板收银.a2de402b.png";